<template>
    <div>
        <loadingScreen :isLoading="isLoading"/>
        <div class="page-wrapper" id="wrapper">
            <nav id="sidebar" class="sidebar-wrapper">
                <div class="sidebar-brand">
                    <a class="">
                        <router-link to="/" @click="isCompany = false">
                            <img style="max-width: 250px; margin:auto; width: 176px; margin-top: 5px"
                                 alt="R2 Soft"
                                 src="@/assets/img/logo-pb.png"
                            >
                        </router-link>
                    </a>
                </div>
                <div class="sidebar-content" style="height: 100%;">
                    <menu-component v-if="!companyId"/>
                    <menu-component v-if="companyId" :companyId="companyId"/>
                </div>
            </nav>
            <div class="page-content">
                <div v-if="impersonation"
                     class="impersonation-banner d-flex align-items-center justify-content-between px-3 py-2">
                    <span><i class="icon-user mr-2"/>Você está simulando
                        <strong>{{ impersonation.target?.name }}</strong>
                        ({{ impersonation.target?.email }}) — expira às {{ impersonationExpiresAt }}</span>
                    <button type="button" class="btn btn-sm btn-dark" @click="stopImpersonation">Sair da simulação</button>
                </div>
                <header class="header app-layout-header">
                    <div class="app-layout-header__left">
                        <div class="toggle-btns">
                            <a id="toggle-sidebar" style="border-radius: 5px;" href="#"
                               @click.stop.prevent="toggleSidebar()">
                                <i class="icon-list"/>
                            </a>
                            <a id="pin-sidebar" style="border-radius: 5px;" href="#" @click.stop.prevent="pinSidebar()">
                                <i class="icon-list"/>
                            </a>
                        </div>
                    </div>
                    <div class="app-layout-header__center" v-if="!isCompany && companies[0] && toggle">
                        <div class="app-company-switcher">
                            <div class="app-company-switcher-icon">
                                <i class="icon-business_center"></i>
                            </div>
                            <div class="app-company-switcher-field">
                                <span class="app-company-switcher-label">Empresa ativa</span>
                                <Select2 class="app-company-switcher-select" :settings="{'width': '100%'}"
                                         v-model="companySelected" :options="companies"
                                         :valueToSet="companyId" :disabled="!!impersonation"
                                         @select="mySelectEvent($event)"/>
                            </div>
                        </div>
                    </div>
                    <div class="app-layout-header__right">
                        <ul class="header-actions right-content">
                            <li v-if="hasFailedJobs" class="failed-jobs-action" data-cy="header_failed_jobs_badge">
                                <span class="failed-jobs-badge" role="status" title="Existem registros na tabela failed_jobs">
                                    <span class="failed-jobs-badge-icon">
                                        <i class="icon-alert-triangle"/>
                                    </span>
                                    <span class="failed-jobs-badge-text">Failed jobs</span>
                                    <span class="failed-jobs-badge-pulse" aria-hidden="true"/>
                                </span>
                            </li>
                            <li class="theme-toggle-action">
                                <button class="theme-toggle-button" :class="{'theme-toggle-button-active': darkTheme === 'ativo'}" type="button" :title="darkTheme === 'ativo' ? 'Tema noturno ativo' : 'Tema diurno ativo'" aria-label="Alternar tema" @click="changeTheme">
                                    <span v-if="darkTheme !== 'ativo'" class="theme-toggle-icon theme-toggle-icon-light">
                                        <i class="icon-sun"></i>
                                    </span>
                                    <span v-else class="theme-toggle-icon theme-toggle-icon-dark">
                                        <i class="icon-cloud1"></i>
                                    </span>
                                </button>
                            </li>
                            <profile :isSecurity="havePassword" :user="profile" @logout="logout"
                                     @update="setProfileModal()"/>
                        </ul>
                    </div>
                </header>
                <div class="main-container">
                    <router-view/>
                    <modal-company-component v-if="showModal" load-permissions
                                              @alterPermissions="mySelectEvent"/>
                    <input type="hidden" name="triger" id="profileTrigger" data-target="#modalProfile"
                           data-toggle="modal">
                    <button type="button" id="oauthNotificationsTrigger" data-target="#oauthNotificationsModal"
                            data-toggle="modal" hidden></button>
                    <modal :modal-xl="true" id-modal="oauthNotificationsModal" title-modal="Avisos e Notificações"
                           :hide-close="oauthNotificationIdsWithAcceptance.length > 0" @close="closeOauthNotificationsModal">
                        <template v-slot:title>
                            <div class="oauth-notifications-title">
                                <span class="oauth-notifications-title-icon">
                                    <i class="fa fa-bell"></i>
                                </span>
                                <span class="oauth-notifications-title-texts">
                                    <span class="oauth-notifications-title-text">Avisos importantes para sua empresa</span>
                                    <small class="oauth-notifications-title-sub">Leia as informações abaixo para continuar usando o sistema.</small>
                                </span>
                            </div>
                        </template>
                        <div class="modal-body oauth-notifications-modal-body p-0">
                            <div class="oauth-notifications-card">
                                <div class="oauth-notifications-list">
                                    <div v-for="notification in oauthNotifications" :key="notification.id"
                                         class="oauth-notification-card"
                                         :class="{'oauth-notification-card-required': notification.requires_acceptance}">
                                        <div class="oauth-notification-card-header">
                                            <small>{{ notification.title }}</small>
                                            <span v-if="notification.requires_acceptance" class="oauth-notification-badge">
                                                Exige aceite
                                            </span>
                                        </div>
                                        <div class="oauth-notification-card-content">
                                            <div v-if="notification.content_type === 'image'" class="oauth-notification-image">
                                                <img :src="notification.image_url" :alt="notification.title">
                                            </div>
                                            <div v-else-if="notification.content_type === 'html'" v-html="notification.message"></div>
                                            <div v-else class="oauth-notification-text">{{ notification.message }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer oauth-notifications-footer">
                            <span v-if="oauthNotificationIdsWithAcceptance.length > 0" class="oauth-notifications-footer-note">
                                Ao clicar em aceitar, sua ciência será registrada e este aviso não será exibido novamente.
                            </span>
                            <span v-else class="oauth-notifications-footer-note">
                                Este aviso poderá aparecer novamente enquanto estiver ativo dentro do período configurado.
                            </span>
                            <button type="button" id="oauthNotificationsClose" data-dismiss="modal" hidden></button>
                            <button v-if="oauthNotificationIdsWithAcceptance.length > 0" type="button"
                                    class="btn oauth-notifications-btn oauth-notifications-btn--primary"
                                    :disabled="acceptingOauthNotifications" @click="acceptOauthNotifications">
                                <span v-if="acceptingOauthNotifications"><i class="fa fa-spinner fa-spin"></i> Processando...</span>
                                <span v-else>Aceito e estou ciente</span>
                            </button>
                            <button v-else type="button" class="btn oauth-notifications-btn oauth-notifications-btn--secondary"
                                    data-dismiss="modal" @click="closeOauthNotificationsModal">
                                Entendi
                            </button>
                        </div>
                    </modal>
                    <div class="modal fade" id="modalProfile" data-backdrop="static" role="dialog"
                         aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog modal-xl" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="footerCenterBtnsModalLabel">
                                        <slot name="title">{{ t('APP.PROFILE') }}</slot>
                                    </h5>
                                    <button type="button" class="closeX" id="closeProfile" data-dismiss="modal"
                                            aria-label="Close"
                                            @click="closeFirstModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <profile-modal v-if="openProfile" :profileIndex="profile"
                                               @update="selectCompany()"></profile-modal>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" name="imageCropper" id="imageCropper" data-target="#modalCropper"
                           data-toggle="modal">
                    <cropper-img @cropperUpdate="isCropping = false"/>
                    <input type="hidden" name="triger" id="profileTrigger" data-target="#modalPassword"
                           data-toggle="modal">
                    <div class="modal fade" id="modalPassword" data-backdrop="static" role="dialog"
                         aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="footerCenterBtnsModalLabel">
                                        <slot name="title">{{ t('APP.PROFILE') }}</slot>
                                    </h5>
                                    <button type="button" class="closeX" id="closeProfile" data-dismiss="modal"
                                            aria-label="Close"
                                            @click="closeFirstModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <password-modal v-if="openProfile" :profileIndex="profile"
                                                @update="selectCompany"></password-modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {useI18n} from 'vue-i18n';
import User from '@/services/user';
import {defineComponent} from 'vue';
import jwt_decode from 'jwt-decode';
import {mapActions, mapState} from 'vuex';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import 'vue-advanced-cropper/dist/style.css';
import {event} from 'vue-gtag';
import Profile from '@/components/layouts/profile';
import CropperImg from '@/components/layouts/cropper';
import MenuComponent from '@/components/layouts/menuComponent';
import ModalCompanyComponent from '@/components/layouts/modalCompanyComponent';
import LoadingScreen from '@/components/layouts/loadScreenComponent.vue';
import profileModal from '@/components/layouts/profileModalComponent.vue';
import passwordModal from '@/components/layouts/changePasswordComponent.vue';
import Notification from '@/services/Notification';
import FailedJobs from '@/services/FailedJobs';
import Modal from '@/components/modal.vue';
import {isImpersonating, getImpersonationInfo} from '@/Helpers/global/Impersonation';

export default defineComponent({
    name: 'AppLayout',
    components: {
        Profile,
        Select2,
        CropperImg,
        profileModal,
        passwordModal,
        LoadingScreen,
        MenuComponent,
        ModalCompanyComponent,
        Modal,
    },
    setup() {
        const login = () => {
            event('login', {method: 'Google'});
        };
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast, login};
    },
    data() {
        return {
            profile: null,
            companiesAux: [],
            toggle: true,
            isCropping: false,
            havePassword: true,
            openProfile: false,
            openPassword: false,
            companyModal: null,
            companySelected: '',
            companyNotLoad: false,
            showSelect2: this.$route.name != 'Company',
            companyId: localStorage.getItem('companyId'),
            oauthNotifications: [],
            oauthNotificationIdsWithAcceptance: [],
            acceptingOauthNotifications: false,
            impersonation: isImpersonating() ? getImpersonationInfo() : null,
            hasFailedJobs: false,
        };
    },
    computed: {
        ...mapState({
            image: 'image',
            darkTheme: 'darkTheme',
            minutesForExpiration: 'minutesForExpiration',
            pinned: 'pinned',
            toggled: 'toggled',
            isLoading: 'isLoading',
            showModal: 'showModal',
            companies: 'companies',
            isCompany: 'isCompany',
            oneToExpire: 'oneToExpire',
            fiveToExpire: 'fiveToExpire',
            closeAlertRefresh: 'closeAlertRefresh',
            showReahtorizationAlert: 'showReahtorizationAlert',
        }),
        impersonationExpiresAt() {
            return this.impersonation?.expiresAt
                ? this.impersonation.expiresAt.toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'})
                : '';
        },
    },
    watch: {
        minutesForExpiration() {
            let currentTime = new Date().getTime() / 1000.0;
            if (currentTime > this.$store.state.fiveToExpire){
                this.showAlert();
            }
        },
        showReahtorizationAlert: function () {
            if (this.showReahtorizationAlert == 5 || this.showReahtorizationAlert == 1) {
                this.showAlert();
            } else if (!this.showReahtorizationAlert) {
                this.$swal.close();
            }
        },
        toggled: function () {
            this.toggle = !(this.toggled);
        },
    },
    mounted() {
        this.startTime();
        this.profile = JSON.parse(localStorage.getItem('user'));
        //  this.indexUser(jwt_decode(localStorage.getItem('access_token')).idUsuario);
        this.startCompany();
        this.createGoogletagmanager();
        this.getHasConfigClickSign();
        this.checkPreLogin();
        this.$store.dispatch('ActionRefreshTokenTime');
        this.loadOauthNotifications();
        this.checkFailedJobs();
    },
    created() {
        this.$store.commit('startCompaniesToken');
    },
    methods: {
        ...mapActions({
            getHasConfigClickSign: 'getHasConfigClickSign'
        }),
        changeTheme() {
            if (this.darkTheme === 'ativo') {
                localStorage.removeItem('darkTheme');
                this.$store.state.darkTheme = false;
                return;
            }

            localStorage.setItem('darkTheme', 'ativo');
            this.$store.state.darkTheme = 'ativo';
        },
        createGoogletagmanager() {
            setTimeout(() => {
                const token = jwt_decode(localStorage.getItem('access_token'));
                if (token && process.env.NODE_ENV === 'production') {
                    const body = document.getElementsByTagName('body')[0];
                    const script = document.createElement('script');
                    script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-EX1N4ML033');
                    script.async = true;
                    const userName = token.name;
                    const companyId = localStorage.getItem('companyId');
                    let companyName = '';
                    if (this.companies?.length && companyId) {
                        this.companies.forEach(item => {
                            if (item.id === companyId) {
                                companyName = item.text;
                            }
                        });
                    }
                    body.appendChild(script);
                    window.dataLayer = window.dataLayer || [];
                    this.gtag('js', new Date());
                    if (companyName.length > 15) {
                        companyName = companyName.substring(0, 15);
                    }
                    this.gtag('config', 'G-EX1N4ML033', {
                        'page_title': companyName + ' - ' + userName,
                    });
                    this.gtag('event', 'screen_view', {
                        'app_name': 'R2 Disponibilidade',
                        'screen_name': userName,
                    });
                }
            }, 4000);
        },
        gtag() {
            window.dataLayer.push(arguments);
        },
        logout() {
            this.$store.dispatch('ActionSingOut');
            this.$router.push({
                name: 'Login',
            });
        },
        checkPreLogin()
        {
            let token = jwt_decode(localStorage.getItem('access_token'));
            if (token?.pre_login){
                this.selectCompany();
            }
        },
        async mySelectEvent(event) {
            if (this.impersonation) return;
            this.$store.commit('changeLoading', true);
            this.companyId = event.id;
            localStorage.removeItem('companyId');
            localStorage.setItem('companyId', event.id);
            localStorage.removeItem('allotmentId');
            localStorage.removeItem('userAllotmentId');
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.removeItem('access_token_custom');
            sessionStorage.removeItem('refresh_token_custom');
            await User.alterCompanyPermissionsUser( {
                company: event.company_id,
                connection: event.id,
            }).then(async (resp) => {
                resp.data.companyId = event.id;
                await this.$store.dispatch('ActionDoLoginSecurity', resp.data);
                this.$router.go();
            }).catch((err) => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            })
        },
        async checkFailedJobs() {
            // Somente token com "anonimo": true (Adm R2 Soft) consulta; os demais nem fazem a requisicao.
            try {
                if (!localStorage.getItem('access_token') || !this.$isAnonymous()) {
                    return;
                }
                const {data} = await FailedJobs.exists();
                this.hasFailedJobs = !!data?.hasFailedJobs;
            } catch (e) {
                this.hasFailedJobs = false;
            }
        },
        async loadOauthNotifications() {
            if (!localStorage.getItem('access_token') || !localStorage.getItem('companyId') || this.isAuthenticatedUserRealtor()) {
                return;
            }

            await Notification.pending().then((resp) => {
                const notifications = Array.isArray(resp.data) ? resp.data.filter(Boolean) : [];
                if (!notifications.length) {
                    return;
                }

                this.showOauthNotificationsModal(notifications);
            }).catch(() => {});
        },
        isAuthenticatedUserRealtor() {
            const roles = jwt_decode(localStorage.getItem('access_token'))?.roles || [];
            return !Object.values(roles).find(role => role === 'group_adm');
        },
        showOauthNotificationsModal(notifications) {
            this.oauthNotifications = notifications;
            this.oauthNotificationIdsWithAcceptance = notifications
                .filter(notification => !!notification.requires_acceptance)
                .map(notification => notification.id);

            this.$nextTick(() => {
                document.getElementById('oauthNotificationsTrigger')?.click();
            });
        },
        async acceptOauthNotifications() {
            this.acceptingOauthNotifications = true;
            await Promise.all(this.oauthNotificationIdsWithAcceptance.map(id => Notification.accept(id))).then(() => {
                this.closeOauthNotificationsModal();
                document.getElementById('oauthNotificationsClose')?.click();
            }).catch(() => {
                this.toast.error('Não foi possível registrar o aceite da notificação.');
            }).finally(() => {
                this.acceptingOauthNotifications = false;
            });
        },
        closeOauthNotificationsModal() {
            this.oauthNotifications = [];
            this.oauthNotificationIdsWithAcceptance = [];
        },
        startCompany() {
            document.body.classList.remove('authentication');
            this.companySelected = localStorage.getItem('companyId');
        },
        startTime() {
            var date = new Date();
            var currentTime = new Date(date).getTime() / 1000.0;
            if (currentTime > this.expirationTime) {
                this.$swal.close();
            }
        },
        selectCompany() {
            const companyId = localStorage.getItem('companyId');
            if (this.companies.length == 1) {
                this.$store.commit('showModalSelectCompany', false);
                this.companyId = this.companies[0].id;
                this.companySelected = this.companies[0].id;
                localStorage.setItem('companyId', this.companies[0].id);
                this.mySelectEvent(this.companies[0]);
            } else if (!companyId && this.companies[0]) {
                this.$store.commit('showModalSelectCompany', true);
            }
        },
        async stopImpersonation() {
            this.$store.commit('changeLoading', true);
            await this.$store.dispatch('ActionStopImpersonation');
            window.location.href = '/';
        },
        showAlert() {
            if (this.impersonation) {
                this.$swal.fire({
                    title: `A sessão simulada expira em ${this.minutesForExpiration} minuto(s).`,
                    confirmButtonText: 'OK',
                });
                return;
            }
            this.$swal.fire({
                title: this.t('GENERAL.MSG.SOME_TIME_TO_END_SESSION', {time: this.minutesForExpiration}),
                showCloseButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonText: `Renovar`,
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    await this.$store.dispatch('ActionRefreshToken');
                    this.$store.commit('changeLoading', false);
                    return;
                }
                let currentTime = new Date().getTime() / 1000.0;
                if (currentTime > this.$store.state.expirationTime) {
                    this.$store.dispatch('ActionSingOut');
                    this.$router.push({name: 'Login'});
                }
            }).catch(() => {
                this.$store.dispatch('ActionSingOut');
                this.$router.push({name: 'Login'});
            });
        },
        pinSidebar() {
            if (this.pinned) {
                document.getElementById('wrapper').classList.remove('pinned');
            } else {
                document.getElementById('wrapper').classList.add('pinned');
                document.getElementById('configSubmenu').classList.remove('show');
            }
            this.$store.commit('pinSidebar');
        },
        toggleSidebar() {
            if (this.toggled) {
                document.getElementById('wrapper').classList.remove('toggled');
            } else {
                document.getElementById('wrapper').classList.add('toggled');
                document.getElementById('configSubmenu').classList.remove('show');
            }
            this.$store.commit('toggleSidebar');
        },
        async setProfileModal() {
            this.$store.commit('changeLoading', true);
            this.$store.commit('setImageCropped', null);
            let userId = jwt_decode(localStorage.getItem('access_token')).idUsuario;
            await User.show(userId).then(resp => {
                this.profile = resp.data;
                this.openProfile = true;
            }).catch(error => this.errorMsg(error)).finally(() => this.$store.commit('changeLoading', false));
        },
        async indexUser(id) {
            await User.show(id).then(resp => {
                if (resp.data.havePassword === false) {
                    this.havePassword = false;
                }
                this.profile = resp.data;
                if (!resp.data.phones[0]) {
                    if (localStorage.getItem('firstProfileClosed') == null || localStorage.getItem('firstProfileClosed') == 'true') {
                        localStorage.setItem('firstProfileClosed', true);
                        document.getElementById('profileTrigger').click();
                        this.openProfile = true;
                    }
                } else {
                    this.selectCompany();
                }
            }).catch(error => this.errorMsg(error));
        },
        closeFirstModal() {
            if (localStorage.getItem('firstProfileClosed') == 'true') {
                localStorage.setItem('firstProfileClosed', false);
            }
        },
    },
});

</script>
<style lang="less">
.size {
    width: 200px !important;
}

.app-layout-header {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    column-gap: 1rem;
}

.app-layout-header__left,
.app-layout-header__right {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

.app-layout-header__left {
    grid-column: 1;
}

.app-layout-header__center {
    grid-column: 2;
    justify-self: center;
    width: 42vw;
    max-width: 420px;
}

.app-layout-header__right {
    grid-column: 3;
    justify-self: end;
}

.theme-toggle-action {
    display: flex;
    align-items: center;
    justify-content: center;
}

.theme-toggle-button {
    width: 40px;
    height: 38px;
    padding: 0;
    border: 1px solid rgba(14, 94, 78, 0.2);
    border-radius: 10px;
    background: linear-gradient(145deg, #ffffff, #eef7f4);
    box-shadow: 0 8px 18px rgba(31, 45, 61, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.95);
    color: #0e5e4e;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
}

.theme-toggle-button::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(14, 94, 78, 0.14), transparent 55%);
    opacity: 0;
    transition: opacity 0.18s ease;
}

.theme-toggle-button:hover,
.theme-toggle-button:focus {
    border-color: rgba(14, 94, 78, 0.36);
    background: linear-gradient(145deg, #ffffff, #e6f4ef);
    box-shadow: 0 12px 26px rgba(31, 45, 61, 0.16), inset 0 1px 0 rgba(255, 255, 255, 1);
    color: #0a4b3f;
    outline: none;
    transform: translateY(-1px);
}

.theme-toggle-button:hover::before,
.theme-toggle-button:focus::before {
    opacity: 1;
}

.theme-toggle-button:active {
    box-shadow: 0 5px 14px rgba(31, 45, 61, 0.12), inset 0 2px 5px rgba(14, 94, 78, 0.12);
    transform: translateY(0);
}

.theme-toggle-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: relative;
    z-index: 1;
}

.theme-toggle-icon-light {
    color: #f59e0b;
}

.theme-toggle-icon-dark {
    color: #0f766e;
}

.failed-jobs-action {
    display: flex;
    align-items: center;
    margin-right: 0.6rem;
}

.failed-jobs-badge {
    height: 38px;
    padding: 0 0.85rem 0 0.4rem;
    border: 1px solid rgba(220, 38, 38, 0.22);
    border-radius: 10px;
    background: linear-gradient(145deg, #ffffff, #fef2f2);
    box-shadow: 0 8px 18px rgba(31, 45, 61, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.95);
    color: #b91c1c;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    cursor: default;
    user-select: none;
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.failed-jobs-badge:hover {
    border-color: rgba(220, 38, 38, 0.38);
    box-shadow: 0 12px 26px rgba(185, 28, 28, 0.14), inset 0 1px 0 rgba(255, 255, 255, 1);
    transform: translateY(-1px);
}

.failed-jobs-badge-icon {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    background: linear-gradient(145deg, #ef4444, #dc2626);
    box-shadow: 0 4px 10px rgba(220, 38, 38, 0.3);
    color: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
}

.failed-jobs-badge-text {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    white-space: nowrap;
}

.failed-jobs-badge-pulse {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ef4444;
    position: relative;
}

.failed-jobs-badge-pulse::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: #ef4444;
    animation: failed-jobs-pulse 1.8s ease-out infinite;
}

@keyframes failed-jobs-pulse {
    0% {
        transform: scale(1);
        opacity: 0.7;
    }
    100% {
        transform: scale(2.8);
        opacity: 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .failed-jobs-badge-pulse::after {
        animation: none;
    }
}

@media (max-width: 576px) {
    .failed-jobs-badge {
        padding: 0 0.4rem;
    }

    .failed-jobs-badge-text,
    .failed-jobs-badge-pulse {
        display: none;
    }
}

html.dark-theme .failed-jobs-badge {
    border-color: rgba(248, 113, 113, 0.3);
    background: linear-gradient(145deg, rgba(127, 29, 29, 0.35), rgba(69, 10, 10, 0.45));
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.3);
    color: #fecaca;
}

html.dark-theme .failed-jobs-badge:hover {
    border-color: rgba(248, 113, 113, 0.5);
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.4);
}

.app-company-switcher {
    display: flex;
    align-items: center;
    gap: 0.42rem;
    width: 100%;
    height: 42px;
    padding: 0.32rem 0.44rem;
    border: 1px solid rgba(14, 94, 78, 0.16);
    border-radius: 9px;
    background: #ffffff;
    box-shadow: none;
    transition: border-color .16s ease, background-color .16s ease;
}

.app-company-switcher:hover,
.app-company-switcher:focus-within {
    border-color: rgba(14, 94, 78, 0.34);
    background: #ffffff;
}

.app-company-switcher-icon {
    width: 25px;
    height: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 25px;
    border-radius: 7px;
    background: #f6f8fa;
    color: #0e5e4e;
    font-size: 0.78rem;
    box-shadow: none;
}

.app-company-switcher-field {
    flex: 1;
    min-width: 0;
}

.app-company-switcher-label {
    display: block;
    margin-bottom: 0.08rem;
    color: #727272;
    font-size: 0.60rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0.02em;
}

.app-company-switcher-select.select2-container,
.app-company-switcher .select2-container {
    width: 100% !important;
}

.app-company-switcher .select2-container--default .select2-selection--single {
    height: 20px !important;
    min-height: 20px !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
}

.app-company-switcher .select2-container--default .select2-selection--single .select2-selection__rendered {
    padding-left: 0 !important;
    padding-right: 1.3rem !important;
    color: #1f2937 !important;
    font-size: 0.76rem !important;
    font-weight: 800 !important;
    line-height: 20px !important;
}

.app-company-switcher .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 0 !important;
    right: 0 !important;
    height: 20px !important;
}

.app-company-switcher .select2-container--default .select2-selection--single .select2-selection__arrow b {
    border-top-color: #0e5e4e !important;
}

.app-company-switcher .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
    border-bottom-color: #0e5e4e !important;
}

.app-company-switcher .select2-container--default .select2-selection--single:focus,
.app-company-switcher .select2-container--default.select2-container--focus .select2-selection--single {
    outline: none !important;
    box-shadow: none !important;
}

@media (max-width: 767.98px) {
    .app-layout-header {
        column-gap: 0.55rem;
        padding: 0 0.75rem;
    }

    .app-layout-header__center {
        width: auto;
        min-width: 0;
        flex: 1 1 auto;
        justify-self: stretch;
    }

    .app-company-switcher {
        gap: 0.35rem;
        padding: 0.18rem 0.35rem;
    }

    .app-company-switcher-icon,
    .app-company-switcher-label {
        display: none;
    }

    .app-company-switcher .select2-container--default .select2-selection--single .select2-selection__rendered {
        font-size: 0.72rem !important;
    }
}

.size-modal {
    width: 100% !important;
}

.btn-background {
    width: 100%;
    font-size: large !important;
    font-weight: 600 !important;
    background-color: #adadad !important;
}

.modal-dialog {
    overflow-y: initial !important
}

.modal-row2 {
    max-height: 40vh;
    overflow-y: auto;
}

.modal-row {
    max-height: 40vh;
    overflow-y: auto;
}

.modal-row2::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
    background: transparent !important;
}

.modal-row2::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 10px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-header-color {
    color: white;
    background-color: #0e5e4e !important;
}

.right-content {
    justify-content: flex-end;
}

.swal2-container {
    z-index: 100000000000;
}

.oauth-notifications-modal-body {
    background: transparent;
    color: #263238;
}

#oauthNotificationsModal .modal-dialog {
    align-items: center;
    display: flex;
    margin: 1.75rem auto;
    min-height: calc(100% - 3.5rem);
}

#oauthNotificationsModal .modal-content {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.10), rgba(14, 94, 78, 0.035) 26%, transparent 60%),
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 62%, #f7f9fb 100%);
    border: 1px solid #dce3ea;
    border-radius: 18px;
    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.16);
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    max-height: calc(100vh - 3.5rem);
    min-width: 480px;
    overflow: hidden;
    width: -moz-fit-content;
    width: fit-content;
}

#oauthNotificationsModal .modal-body {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

#oauthNotificationsModal .modal-header {
    background: transparent;
    border-bottom: 0;
    color: #263238;
    padding: 1rem 1rem 0.5rem;
}

#oauthNotificationsModal .modal-header .closeX {
    color: #263238 !important;
    text-shadow: none !important;
}

#oauthNotificationsModal .modal-header .closeX:hover {
    background: rgba(38, 50, 56, 0.08) !important;
    color: #263238 !important;
    opacity: 1 !important;
}

.oauth-notifications-card {
    background: transparent;
    border: 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    margin: 0;
    min-height: 0;
    overflow: visible;
    padding: 0 1rem 1rem;
    position: static;
}

.oauth-notifications-title {
    align-items: center;
    display: flex;
    gap: 0.75rem;
    line-height: 1.3;
}

.oauth-notifications-title-icon {
    align-items: center;
    background: #f6faf9;
    border: 1px solid #e3ece9;
    border-radius: 999px;
    color: #263238;
    display: inline-flex;
    flex: 0 0 36px;
    font-size: 1.05rem;
    height: 36px;
    justify-content: center;
    width: 36px;
}

.oauth-notifications-title-texts {
    display: block;
    min-width: 0;
}

.oauth-notifications-title-text {
    color: #263238;
    display: block;
    font-size: 1.05rem;
    font-weight: 800;
}

.oauth-notifications-title-sub {
    color: #6d7f7b;
    display: block;
    font-size: 0.84rem;
    font-weight: 500;
}

.oauth-notifications-list {
    display: grid;
    gap: 0.65rem;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
}

.oauth-notification-card {
    background: #f6faf9;
    border: 1px solid #e3ece9;
    border-radius: 14px;
    overflow: hidden;
    padding: 0.85rem;
    text-align: left;
}

.oauth-notification-card-required {
    border-color: #b7ddd3;
}

.oauth-notification-card-header {
    align-items: center;
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
    margin-bottom: 0.35rem;
}

.oauth-notification-card-header small {
    color: #6d7f7b;
    display: block;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    line-height: 1.35;
    text-transform: uppercase;
}

.oauth-notification-badge {
    background: #ffffff;
    border: 1px solid #b7ddd3;
    border-radius: 999px;
    color: #0e5e4e;
    flex: 0 0 auto;
    font-size: 0.68rem;
    font-weight: 800;
    padding: 0.26rem 0.62rem;
    text-transform: uppercase;
}

.oauth-notification-card-content {
    color: #344054;
    font-size: 0.95rem;
    line-height: 1.6;
    max-width: 100%;
    overflow-x: hidden;
    word-break: break-word;
}

.oauth-notification-image {
    background: #ffffff;
    border: 1px solid #e3ece9;
    border-radius: 12px;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
    padding: 0.75rem;
    text-align: center;
    width: -moz-fit-content;
    width: fit-content;
}

.oauth-notification-card-content img {
    height: auto !important;
    max-width: 100% !important;
}

.oauth-notification-card-content table {
    max-width: 100% !important;
    width: 100% !important;
}

.oauth-notification-text {
    white-space: pre-line;
}

.oauth-notifications-footer {
    align-items: center;
    background: rgba(246, 250, 249, 0.86);
    border-top: 1px solid #e3ece9;
    display: flex;
    flex-wrap: wrap;
    gap: 0.55rem;
    justify-content: space-between;
    padding: 0.85rem 1rem;
}

.oauth-notifications-footer-note {
    color: #6d7f7b;
    font-size: 0.84rem;
    line-height: 1.4;
    margin-right: auto;
    text-align: left;
}

.oauth-notifications-btn {
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 800;
    margin: 0 !important;
    min-height: 38px;
    padding: 0.52rem 0.95rem;
}

.oauth-notifications-btn--primary {
    background: linear-gradient(135deg, #0e5e4e, #0b7a5f);
    border: 0;
    box-shadow: 0 10px 22px rgba(14, 94, 78, 0.20);
    color: #ffffff;
}

.oauth-notifications-btn--primary:hover,
.oauth-notifications-btn--primary:focus {
    color: #ffffff;
    filter: brightness(1.04);
}

.oauth-notifications-btn--primary:disabled {
    color: #ffffff;
    filter: brightness(0.92);
    opacity: 0.85;
}

.oauth-notifications-btn--secondary {
    background: #ffffff;
    border: 1px solid #b7ddd3;
    color: #0e5e4e;
}

.oauth-notifications-btn--secondary:hover,
.oauth-notifications-btn--secondary:focus {
    background: #e7f4f0;
    color: #0e5e4e;
}

html.dark-theme #oauthNotificationsModal .modal-content {
    background: linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: transparent !important;
    box-shadow: none !important;
}

html.dark-theme #oauthNotificationsModal .modal-header {
    background: transparent !important;
    border-bottom: 0 !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    color: var(--dark-text) !important;
}

html.dark-theme #oauthNotificationsModal .modal-header .closeX {
    color: var(--dark-text) !important;
}

html.dark-theme #oauthNotificationsModal .modal-header .closeX:hover {
    background: rgba(255, 255, 255, 0.08) !important;
    color: var(--dark-text) !important;
}

html.dark-theme .oauth-notification-card,
html.dark-theme .oauth-notification-image,
html.dark-theme .oauth-notifications-footer {
    background: rgba(15, 23, 42, 0.28) !important;
    border-color: rgba(94, 234, 212, 0.14) !important;
}

html.dark-theme .oauth-notifications-title-icon {
    background: rgba(255, 255, 255, 0.06) !important;
    border-color: rgba(255, 255, 255, 0.14) !important;
    color: var(--dark-text) !important;
}

html.dark-theme .oauth-notifications-title-text {
    color: var(--dark-text) !important;
}

html.dark-theme .oauth-notifications-title-sub {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .oauth-notifications-btn--secondary {
    color: var(--dark-primary) !important;
}

html.dark-theme .oauth-notification-card-header small,
html.dark-theme .oauth-notifications-footer-note {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .oauth-notification-card-content {
    color: var(--dark-text) !important;
}

html.dark-theme .oauth-notification-badge {
    background: rgba(20, 184, 166, 0.08) !important;
    border-color: rgba(94, 234, 212, 0.20) !important;
}

html.dark-theme .oauth-notifications-btn--secondary {
    background: rgba(20, 184, 166, 0.08) !important;
    border-color: rgba(94, 234, 212, 0.20) !important;
}

@media (max-width: 575px) {
    #oauthNotificationsModal .modal-header {
        padding: 0.75rem 0.75rem 0.4rem;
    }

    .oauth-notifications-card {
        padding: 0 0.75rem 0.75rem;
    }

    #oauthNotificationsModal .modal-dialog {
        margin: 0.5rem auto;
        min-height: calc(100% - 1rem);
    }

    #oauthNotificationsModal .modal-content {
        max-height: calc(100vh - 1rem);
        min-width: 0;
    }

    .oauth-notification-card-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .oauth-notifications-footer {
        align-items: stretch;
        flex-direction: column;
    }

    .oauth-notifications-footer .btn {
        width: 100%;
    }
}

.user-avatar {
    max-width: 80px !important;
    max-height: 80px !important;
    border-radius: 50% !important;
    margin-bottom: 1.2rem !important;
}

.avatar-size {
    width: 80px !important;
    height: 80px !important;
}

.cropper-size {
    max-width: 350px !important;
    max-height: 275px !important;
}

.avatar .status {
    top: 62px;
    right: 2px;
    width: 25px;
    height: 25px;
    font-size: 18px;
    position: absolute;
    border-radius: 15px;
    border: 4px solid #f0f0f0;
}

.camera {
    right: 1;
    bottom: 0;
    outline: 0;
    cursor: pointer;
    font-size: 18px;
    position: absolute;
    border-radius: 15px;
    background-color: #f0f0f0;
}

.align-items {
    align-items: center;
}

.preview {
    border: dashed 1px rgba(255, 255, 255, 0.25);
}

.cropper {
    height: 100%;
    background: #DDD;
}

.hearder-custom {
    color: #333333 !important;
    background: #ffffff !important;
}

.close-custom {
    color: #000 !important;
}

.border-bottom {
    border-bottom: 1px solid #e6ebf1;
}

.border-top {
    background-color: #f2f4f9;
    border-top: 1px solid #e6ebf1;
}

.lg {
    max-width: 800px !important;
}

.card-hover-scale:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.impersonation-banner {
    background: #ffc107;
    color: #212529;
    font-weight: 500;
    position: sticky;
    top: 0;
    z-index: 1030;
}
</style>
